
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import useColorSystem from '../../hook/useColorSystem';
import { FormattedMessage } from 'react-intl';

import theme from '../../theme';

const ModalFooter = (props) => {
  const {
    media,
    type,
    checkBottonContent,
    cancelBottonContent,
    handelCancel,
    processing,
    handleSubmit,
    entryPath
  } = props;
  const { colorMedia, mainColor, lightColor, darkColor, w01Color } = useColorSystem();

  if (type === 'delete') {
    return (
      <>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            padding: '16px 40px 0',
          }}>

          <Box>
            <Button
              variant="text-cancel"
              onClick={handelCancel}
              disabled={processing}
            >
              {cancelBottonContent ? cancelBottonContent : <FormattedMessage id="common.button.cancel" />}
            </Button>

            <Button
              variant="contained"
              disabled={processing}
              onClick={handleSubmit}
              color="error"
              sx={{
                color: '#fff',
              }}
            >
              {checkBottonContent}
            </Button>

          </Box>
        </Box>
      </>
    )
  }

  if (type === 'cancel') {
    return (
      <>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            padding: '16px 30px 0',
            borderTop: `1px solid ${theme.palette.grey.w300}`
          }}>

          <Box>
            <Button
              variant="text-cancel"
              onClick={handelCancel}
              disabled={processing}
            >
              {cancelBottonContent ? cancelBottonContent : <FormattedMessage id="common.button.cancel" />}
            </Button>
          </Box>
        </Box>
      </>
    )
  }

  if (type === 'loadingButton') {
    return (
      <>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            padding: '16px 40px 0',
          }}>

          <Box>
            <Button
              variant="contained"
              endIcon={processing === 'downloadReport' ? <CircularProgress size={16} color="inherit" /> : null}
              disabled={processing === 'downloadReport'}
              onClick={handleSubmit}
              color="system"
            >
              {checkBottonContent}
            </Button>
          </Box>
        </Box>
      </>
    )
  }

  if (type === 'facebook-loadingButton') {
    return (
      <>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            padding: '16px 40px 0',
          }}>

          <Box>
            <Button
              variant="contained"
              endIcon={processing === 'downloadReport' ? <CircularProgress size={16} color="inherit" /> : null}
              disabled={processing === 'downloadReport'}
              onClick={handleSubmit}
              color="facebook"
            >
              {checkBottonContent}
            </Button>
          </Box>
        </Box>
      </>
    )
  }

  if (type === 'google-loadingButton') {
    return (
      <>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            padding: '16px 40px 0',
          }}>

          <Box>
            <Button
              variant="contained"
              endIcon={processing === 'downloadReport' ? <CircularProgress size={16} color="inherit" /> : null}
              disabled={processing === 'downloadReport'}
              onClick={handleSubmit}
              color="google"
            >
              {checkBottonContent}
            </Button>
          </Box>
        </Box>
      </>
    )
  }

  if (type === 'line-loadingButton') {
    return (
      <>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            padding: '16px 40px 0',
          }}>

          <Box>
            <Button
              variant="contained"
              endIcon={processing === 'downloadReport' ? <CircularProgress size={16} color="inherit" /> : null}
              disabled={processing === 'downloadReport'}
              onClick={handleSubmit}
              color="line"
            >
              {checkBottonContent}
            </Button>
          </Box>
        </Box>
      </>
    )
  }

  if (type === 'line-loadingButton&cancel') {
    return (
      <>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            padding: '16px 40px 0',
          }}>

          <Box>
            <Button
              variant="text-cancel"
              onClick={handelCancel}
              disabled={processing}
            >
              {cancelBottonContent ? cancelBottonContent : <FormattedMessage id="common.button.cancel" />}
            </Button>
            <Button
              variant="contained"
              endIcon={processing === 'downloadReport' ? <CircularProgress size={16} color="inherit" /> : null}
              disabled={processing === 'downloadReport' ? true : false}
              onClick={handleSubmit}
              color="line"
            >
              {checkBottonContent}
            </Button>
          </Box>
        </Box>
      </>
    )
  }

  if (type === 'facebook-Button') {
    return (
      <>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'end',
            padding: '16px 40px 0',
            borderTop: `1px solid ${theme.palette.grey.w300}`
          }}>

          <Box>
            <Button
              variant="text-cancel"
              onClick={handelCancel}
              disabled={processing}
            >
              {cancelBottonContent ? cancelBottonContent : <FormattedMessage id="common.button.cancel" />}
            </Button>
            <Button
              variant="contained"
              disableElevation
              disabled={processing}
              onClick={handleSubmit}
              sx={{
                color: '#fff',
                backgroundColor: theme.palette.facebook.main,
                "&:hover": {
                  backgroundColor: theme.palette.facebook.dark,
                }
              }}
            >
              {checkBottonContent}
            </Button>
          </Box>
        </Box>
      </>
    )
  }

  if (type === 'google-Button') {
    return (
      <>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'end',
            padding: '16px 40px 0',
            borderTop: `1px solid ${theme.palette.grey.w300}`
          }}>

          <Box>
            <Button
              variant="text-cancel"
              onClick={handelCancel}
              disabled={processing}
            >
              {cancelBottonContent ? cancelBottonContent : <FormattedMessage id="common.button.cancel" />}
            </Button>
            <Button
              variant="contained"
              disableElevation
              disabled={processing}
              onClick={handleSubmit}
              sx={{
                color: '#fff',
                backgroundColor: theme.palette.google.main,
                "&:hover": {
                  backgroundColor: theme.palette.google.dark,
                }
              }}
            >
              {checkBottonContent}
            </Button>
          </Box>
        </Box>
      </>
    )
  }

  if (type === 'line-Button') {
    return (
      <>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'end',
            padding: '16px 40px 0',
            borderTop: `1px solid ${theme.palette.grey.w300}`
          }}>

          <Box>
            <Button
              variant="text-cancel"
              onClick={handelCancel}
              disabled={processing}
            >
              {cancelBottonContent ? cancelBottonContent : <FormattedMessage id="common.button.cancel" />}
            </Button>
            <Button
              variant="contained"
              disableElevation
              disabled={processing}
              onClick={handleSubmit}
              sx={{
                color: '#fff',
                backgroundColor: theme.palette.line.main,
                "&:hover": {
                  backgroundColor: theme.palette.line.dark,
                }
              }}
            >
              {checkBottonContent}
            </Button>
          </Box>
        </Box>
      </>
    )
  }

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'end',
          padding: '16px 40px 0',
          borderTop: `1px solid ${theme.palette.grey.w300}`
        }}>

        <Box>
          <Button
            variant="text-cancel"
            onClick={handelCancel}
            disabled={processing}
          >
            {cancelBottonContent ? cancelBottonContent : <FormattedMessage id="common.button.cancel" />}
          </Button>

          <Button
            variant="contained"
            disableElevation
            endIcon={processing === 'downloadReport' ? <CircularProgress size={16} color="inherit" /> : null}
            disabled={processing === 'downloadReport'}            
            onClick={handleSubmit}
            sx={{
              color: '#fff',
              backgroundColor: mainColor,
              "&:hover": {
                backgroundColor: darkColor,
              }
            }}
          >
            {checkBottonContent ? checkBottonContent : <FormattedMessage id="common.button.confirm" />}
            </Button>

        </Box>
      </Box>
    </>
  )
}

export default ModalFooter;